






























































































































































import {
  AuthService,
  BidManagementBidService as bidApi,
  LiveManagementLiveService,
  StoreHistoryManagementOrderMetaDTO,
} from "@/common/api";
import { ORDER_TYPE } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatQueryToArray } from "@/common/utils";
import BidDetailComponent from "@/components/admin/bid/bidDetailComponent.vue";
import QChat from "@/components/common/qChat.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import qSelectLives from "@/components/common/qSelectLives.vue";
import { STATUS_ARRAY_LIVECARP } from "@/model/order";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BidListComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    BidDetailComponent,
    QMultiSelect,
    QCalendar,
    QChat,
    qSelectLives,
  },
})
export default class BidListComponent extends Vue {
  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public searchStatusOptions = [
    ...[this.selectedAllStatus],
    ...STATUS_ARRAY_LIVECARP,
  ];
  public orders = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public connection: WebSocket;
  public connectionId = null;

  public dateConfig = {
    enableTime: false,
    dateFormat: "Y-m-d",
    defaultHour: 0,
  };

  public headers = [];

  public initHeaders = [
    { id: "order_code", name: "購入No", order: "" },
    { id: "created_at", name: "落札日時", order: "" },
    { id: "title", name: "イベント名", order: "" },
    { id: "created_by", name: "購入者" },
    { id: "price", name: "小計" },
    { id: "total_other_price", name: "その他" },
    {
      id: "p_point",
      name: "pt利用",
      sub_name: "S",
      sub_name_class: "PointMark",
    },
    {
      id: "l_point",
      name: "pt利用",
      sub_name: "L",
      sub_name_class: "PointMark",
    },
    { id: "total", name: "支払額" },
    { id: "payment_method", name: "支払方法" },
    { id: "status", name: "状態", order: "desc" },
    { id: "", name: "" },
    { id: "", name: "" },
  ];

  public initSearch = {
    name: null,
    code: null,
    livecarpId: null,
    status: ["all"],
    startDate: null,
    endDate: null,
    sort: "status",
    direction: "desc",
    perPage: 30,
    page: 1,
  };

  public searchParams: any = {};
  public meta: StoreHistoryManagementOrderMetaDTO = {
    start: "",
    end: "",
    point: "0",
  };

  public liveCarpList = [];
  public livecarp = null;

  public created() {
    this.connectSocket();
  }

  public async mounted() {
    const query = this.$router.currentRoute.query;
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));

    await this.getLivecarpItems();
    if (query.livecarpId) {
      this.livecarp = this.liveCarpList.find(
        (object) => object.id === Number(query.livecarpId),
      );
    }
    if (query.id) {
      this.livecarp = this.liveCarpList.find(
        (object) => object.id === Number(query.id),
      );
    }
    this.initalSearch();
    this.filterData();
  }

  public initalSearch(): void {
    let query = this.$router.currentRoute.query;
    query = formatQueryToArray(query, "status");
    this.searchParams = {
      ...this.initSearch,
      ...query,
    };
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    this.searchParams.livecarpId = this.livecarp?.id;
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    try {
      if (query.status && query.status.includes("all")) {
        query.status = [];
      }
      const result = await bidApi.adminBid(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.orders = result.data.orders;
      this.meta = result.data.meta;
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async exportCsv() {
    try {
      const query = {
        ...this.searchParams,
        ...{
          status: this.searchParams.status.includes("all")
            ? []
            : this.searchParams.status,
        },
      };
      const result: any = await bidApi.adminBidCsv(query);

      const aTag = document.createElement("a");
      aTag.href = result.data.url;
      aTag.target = "_blank";
      document.body.append(aTag);
      aTag.click();
      aTag.remove();
    } catch (error) {
      console.log(error);
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public showDetail(order) {
    (this.$refs.bidDetailComponent as BidDetailComponent).show(order.id);
  }

  public openChat(order) {
    (this.$refs.chatComponent as QChat).show(order);
  }

  public showFullName(order) {
    return order.member?.last_name + "" + order.member?.first_name;
  }

  public getNameStatus(status) {
    return STATUS_ARRAY_LIVECARP.find((item) => item.id === status)?.name;
  }

  public async getLivecarpItems() {
    this.liveCarpList = [];
    const result: any = await LiveManagementLiveService.adminLiveListForSelect(
      {},
    );
    this.liveCarpList = result.data.livecarp;
  }

  public async connectSocket() {
    const result = await AuthService.connectSocketUrl({});
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId &&
        data.event === "Refresh" &&
        data?.type &&
        data?.type === ORDER_TYPE.LIVECARP
      ) {
        this.filterData(false, { disabledLoadinng: true });
      }
    });
    this.connection.addEventListener("open", () => {
      const body: any = {
        action: "subscribe",
        topic: "admin/notice",
      };

      this.connection.send(JSON.stringify(body));
    });
  }

  public beforeDestroy() {
    if (this.connection) {
      this.connection.close();
      this.connection = null;
    }
  }

  public convertDateToSlashFormat(date) {
    if (date) {
      return date.replaceAll("-", "/");
    }

    return "";
  }
}
